import React from 'react';

const LogoStubSquareIcon = () => {
	return (
		<svg
			fill='none'
			height='101'
			viewBox='0 0 101 101'
			width='101'
		>
			<rect
				fill='#E6E6E6'
				height='100'
				rx='4'
				width='100'
				x='0.5'
				y='0.5'
			/>
			<rect
				fill='#E6E6E6'
				height='100'
				rx='50'
				width='100'
				x='0.5'
				y='0.5'
			/>
			<g clipPath='url(#clip0_14935_412198)'>
				<path
					d='M58.3125 45.0312C58.3125 45.6529 58.0656 46.249 57.626 46.6885C57.1865 47.1281 56.5904 47.375 55.9688 47.375C55.3471 47.375 54.751 47.1281 54.3115 46.6885C53.8719 46.249 53.625 45.6529 53.625 45.0312C53.625 44.4096 53.8719 43.8135 54.3115 43.374C54.751 42.9344 55.3471 42.6875 55.9688 42.6875C56.5904 42.6875 57.1865 42.9344 57.626 43.374C58.0656 43.8135 58.3125 44.4096 58.3125 45.0312ZM70.8125 36.4375V61.4375V64.5625C70.8125 65.3913 70.4833 66.1862 69.8972 66.7722C69.3112 67.3583 68.5163 67.6875 67.6875 67.6875H33.3125C32.4837 67.6875 31.6888 67.3583 31.1028 66.7722C30.5167 66.1862 30.1875 65.3913 30.1875 64.5625V58.3125V36.4375C30.1875 35.6087 30.5167 34.8138 31.1028 34.2278C31.6888 33.6417 32.4837 33.3125 33.3125 33.3125H67.6875C68.5163 33.3125 69.3112 33.6417 69.8972 34.2278C70.4833 34.8138 70.8125 35.6087 70.8125 36.4375ZM67.6875 57.668V36.4375H33.3125V54.543L40.4805 47.375C41.0688 46.7953 41.8616 46.4704 42.6875 46.4704C43.5134 46.4704 44.3062 46.7953 44.8945 47.375L53.625 56.1055L57.668 52.0625C58.2563 51.4828 59.0491 51.1579 59.875 51.1579C60.7009 51.1579 61.4937 51.4828 62.082 52.0625L67.6875 57.668Z'
					fill='#B3B3B3'
				/>
			</g>
			<defs>
				<clipPath id='clip0_14935_412198'>
					<rect
						fill='white'
						height='50'
						transform='translate(25.5 25.5)'
						width='50'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default LogoStubSquareIcon;
